import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../../lib';


const formName = 'Directional & Wayfinding Signs';

const defaultValues = {
  'Quantity': '',
  'Size': '',
  'Content': '',
  'Mount-type': '',
  'Match-existing-signage': '',
  'Consulting-required': '',
  'Installation-required': '',
};

const fields = [
  'Quantity',
  'Size',
  'Content',
  'Mount-type',
  'Match-existing-signage',
  'Consulting-required',
  'Installation-required',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />

      <Textarea
        textareaId='Content'
        textareaName='Content'
        register={register}
        formState={formState}
        label='Content'
        theme={textareaTheme}
      />

      <Radio
        radioId='Mount-type'
        radioName='Mount-type'
        legend='Mount type?'
        options={[
          { value: 'wall-mounted', label: 'Wall mounted' },
          { value: 'suspended', label: 'Suspended' },
          { value: 'projecting', label: 'Projecting' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

      <Radio
        radioId='Match-existing-signage'
        radioName='Match-existing-signage'
        legend='Are we matching existing signage?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Consulting-required'
        radioName='Consulting-required'
        legend='Consulting required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Installation-required'
        radioName='Installation-required'
        legend='Installation required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
